// extracted by mini-css-extract-plugin
export default {"container":"v0dcJ4x7fIVWvLWQd6Di","header":"yLfU5HArUV5a2X9AAEJm","breadcrumbs":"D1XArmkLGugMjrqWsu9O","breadcrumb_link":"zsUmb_vGTTyS0e2Lp08_"};